export default {"src":"/_next/static/media/Recruiter_dashboard.7ede43f3.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};